import { render, staticRenderFns } from "./FilterLocalTreeItem.vue?vue&type=template&id=45824c14&scoped=true"
import script from "./FilterLocalTreeItem.vue?vue&type=script&lang=js"
export * from "./FilterLocalTreeItem.vue?vue&type=script&lang=js"
import style0 from "./FilterLocalTreeItem.vue?vue&type=style&index=0&id=45824c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45824c14",
  null
  
)

export default component.exports